import React, { useEffect, useContext } from 'react'

// utils
import handleNotification from 'utils/toast/handleNotification'

// hooks
import useShare from 'hooks/useShare'
// icons
import { ToastWayniLogo } from 'assets/icons'

// Components
import PrimaryButton from '../../components/primaryButton'
import PageWrapper from '../../components/PageWrapper'
import ProfileUserData from './ProfileUserData'

// Context
import { MeContext } from '../../contexts/me'

export default function MyProfile() {
  const { me } = useContext(MeContext)

  const { successToast } = handleNotification()
  const { handleShare, showButtonCopy, setShareData } = useShare()

  const shareData = {
    text: `Te comparto mis Wayni datos: CVU: ${me?.bank?.internal_account[0]?.cvu}, Nombre: ${me?.profile?.name} ${me?.profile?.surname}, Email: ${me?.profile?.email}, DNI: ${me?.profile?.identification_number}, Celular: ${me?.profile?.phone}`
  }

  useEffect(() => {
    setShareData(shareData)
  }, [me])

  const onCopy = () => {
    navigator.clipboard.writeText(shareData.text)
    successToast('Los datos se han copiado en portapapeles', <ToastWayniLogo />)
  }

  return (
    <PageWrapper title='Mis datos'>
      <div className='md:max-w-564 md:flex md:items-end md:flex-col mx-auto'>
        <ProfileUserData />
        <div className='flex w-full absolute bottom-20 right-0 left-0 px-3 sm:relative sm:px-0 sm:mt-4 sm:right-1/2 sm:top-0 sm:w-48 sm:ml-auto md:w-40 '>
          {showButtonCopy ? (
            <PrimaryButton
              type='button'
              buttonText='Copiar'
              outlined={false}
              primaryButtonFunction={() => {
                onCopy()
              }}
            />
          ) : (
            <PrimaryButton
              type='button'
              isDisabled={showButtonCopy}
              buttonText='Compartir'
              outlined={false}
              isShare
              primaryButtonFunction={() => {
                handleShare()
              }}
            />
          )}
        </div>
      </div>
    </PageWrapper>
  )
}
